"use client";

import { c as _c } from "react/compiler-runtime";
import { ORIENTATION_GUARD_MESSAGES } from "./messages";
import { useOrientation } from "@/hooks/useOrientation";
import { Modal, Stack, Text, Title } from "@mantine/core";
export function OrientationGuard(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    showOverlay
  } = useOrientation();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundOpacity: 0.65
    };
    t2 = {
      transition: "fade",
      duration: 200
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Stack align="center" gap={4}><Title order={5} ta="center" fw={600}>{ORIENTATION_GUARD_MESSAGES.title}</Title><Text c="dimmed" ta="center" size="xs">{ORIENTATION_GUARD_MESSAGES.description}</Text></Stack>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== showOverlay) {
    t4 = <Modal opened={showOverlay} onClose={_temp} centered={true} size="sm" radius="lg" padding="lg" withCloseButton={false} closeOnClickOutside={false} closeOnEscape={false} lockScroll={true} trapFocus={true} returnFocus={false} title={null} zIndex={10000} overlayProps={t1} transitionProps={t2}>{t3}</Modal>;
    $[3] = showOverlay;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <>{children}{t4}</>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
function _temp() {}